/*
 * @Descripttion:
 * @version:
 * @Author: ared
 * @Date: 2022-10-27 14:46:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-20 10:19:42
 */
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { goodsList } from "@home3/homeType";
import { wrapGoodCDN } from "@/utils/cdn";
import { convertToI18 } from "@/utils/count";
import { useEffect, useState } from "react";
import { getGoodsList } from "@/service";
type Props = {
    // goodsList: goodsList;
    // context:any
};
const Index = (props: Props) => {
    const { t, i18n } = useTranslation("home");
    // let { context } = props;
    const [threeGoodsList, setThreeGoodsList] = useState([])
    const handClick = (suburl: string) => {
        // window.location.href =
        //   process.env.publicUrl + "/mobile/products/products";
        window.location.href =
            process.env.mobileUrl +
            "/rank?type=Goods&rankType=breakout";
    };

    useEffect(() => {
    //   first
    if(process.browser){
    const fetchData = async () => {
            let goods = await getGoodsList({},  {});
            let goodsData = [];
            if (goods && goods.code == 0) {
                goodsData =  (goods.data || []).slice(0, 3);
                setThreeGoodsList(goodsData)
            }
          }
        fetchData()    
    }

      return () => {}
    }, [])
    
    return (
        <div className="bg-[#fff] px-[20px]">
            <div className={styles.title + " pb-[20px]"}>
                {t("goodRanking24")}
                <div
                    className={styles.more}
                    onClick={() => handClick("Products")}
                >
                    {t("more")}
                </div>
            </div>
            {/* <div className={styles.time}>{t("update12hour")}</div> */}
            <div className={styles.main}>
                <div className={styles.itemBox}>
                    {(threeGoodsList || []).map((item: any, index: any) => (
                        <div
                            key={index}
                            className={styles.item}
                            onClick={() => handClick("Products")}
                        >
                            <div className="flex items-center">
                                <div className={styles.sort}>#{index + 1}</div>
                                <div className={styles.atr}>
                                    <Image
                                        lazyBoundary="10px"
                                        src={wrapGoodCDN(
                                            item.imagesPrivatization
                                                ? item.imagesPrivatization[0]
                                                    ? item
                                                          .imagesPrivatization[0]
                                                    : ""
                                                : "",
                                            48 * 3
                                        )}
                                        width={480}
                                        height={480}
                                        objectFit="cover"
                                        alt=""
                                        className="rounded-[8px] !border-[1px] !border-solid !border-[#ECECEC]"
                                    ></Image>
                                </div>
                                <div className={styles.info}>
                                    <div className={styles.name}>
                                        {item?.title}
                                    </div>
                                    <div className={styles.price}>
                                        {t("Price")}: ${" " + item?.price}
                                    </div>
                                    <div className={styles.count}>
                                        <div>{t("Revenue")}</div>
                                        <div className="ml-[4px]">
                                            {item?.salesAmountUsd}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="right">
                                <div className={styles.add}>
                                    {convertToI18(item?.soldCount)}
                                </div>
                                <div className={styles.grow}>
                                    {t("Sales")}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default Index;
